// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes animationRotate {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(1turn);
  }
}
/* Add Animation */
@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
.__sidebar_content {
  width: 50px;
  height: 100vh; /* Full viewport height */
  padding: 25px 21px; /* Simplified padding */
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center items vertically */
  align-items: center; /* Center items horizontally */
}

.__menu_item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%; /* Ensure full width */
  padding: 10px 0; /* Adjust padding for spacing */
}

.__item {
  margin: 1rem auto;
  text-align: center; /* Center text */
  width: 100%; /* Ensure item takes full width */
}
.__item:last-child {
  margin-top: auto; /* Flexbox trick to push it to the bottom */
}

.__create_playlist {
  border-radius: 0 0 18px 18px !important;
  border-top: 0 !important;
  color: #000000 !important;
  background-color: #FFEE20 !important;
}

.__open_button {
  border-radius: 18px 18px 0px 0px !important;
  border-bottom: 0 !important;
  color: #000000 !important;
  background-color: #FFEE20 !important;
}
.__open_button svg {
  color: #000000 !important;
}

.____transform {
  transition: transform 0.2s;
}

.navButton {
  background: transparent;
  justify-content: center;
  width: 100%; /* Ensure full width for button */
  height: 90px;
}

.navIcon {
  max-width: 100px;
  max-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/styles/_mixins.scss","webpack://./src/components/LeftBar/index.scss"],"names":[],"mappings":"AAGA;EACE;IACE,oBAAA;ECFF;EDIA;IACE,wBAAA;ECFF;AACF;ADKA,kBAAA;AAYA;EACE;IACE,WAAA;IACA,UAAA;ECJF;EDMA;IACE,MAAA;IACA,UAAA;ECJF;AACF;AA1BA;EACE,WAAA;EACA,aAAA,EAAA,yBAAA;EACA,kBAAA,EAAA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA,EAAA,4BAAA;EACA,mBAAA,EAAA,8BAAA;AA4BF;;AAzBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA,EAAA,sBAAA;EACA,eAAA,EAAA,+BAAA;AA4BF;;AAzBA;EACE,iBAAA;EACA,kBAAA,EAAA,gBAAA;EACA,WAAA,EAAA,iCAAA;AA4BF;AA1BE;EACE,gBAAA,EAAA,2CAAA;AA4BJ;;AAxBA;EACE,uCAAA;EACA,wBAAA;EACA,yBAAA;EACA,oCAAA;AA2BF;;AAxBA;EACE,2CAAA;EACA,2BAAA;EACA,yBAAA;EACA,oCAAA;AA2BF;AAzBE;EACE,yBAAA;AA2BJ;;AAvBA;EACE,0BAAA;AA0BF;;AAvBA;EACE,uBAAA;EACA,uBAAA;EACA,WAAA,EAAA,iCAAA;EACA,YAAA;AA0BF;;AAvBA;EACE,gBAAA;EACA,iBAAA;AA0BF","sourcesContent":["@import \"./colors.scss\";\n@import \"./breakpoints\";\n\n@keyframes animationRotate {\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(1turn);\n  }\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n// Small devices\n@mixin sm {\n  @media (max-width: #{$screen-sm-max}) {\n    @content;\n  }\n}\n\n@mixin upToSm {\n  @media (min-width: #{$screen-sm-min}) {\n    @content;\n  }\n}\n\n// Medium devices\n@mixin md {\n  @media (min-width: #{$screen-md-min}) {\n    @content;\n  }\n}\n\n// Large devices\n@mixin lg {\n  @media (min-width: #{$screen-lg-min}) {\n    @content;\n  }\n}\n\n// Extra large devices\n@mixin xl {\n  @media (min-width: #{$screen-xl-min}) {\n    @content;\n  }\n}\n\n// Custom devices\n@mixin rwd($screen) {\n  @media (min-width: #{$screen}px) {\n    @content;\n  }\n}\n\n@mixin screnRange($min, $max) {\n  @media (min-width: #{$min}px) and (max-width: #{$max}px) {\n    @content;\n  }\n}\n\n@mixin screenHeightRange($min, $max) {\n  @media (min-height: #{$min}px) and (max-height: #{$max}px) {\n    @content;\n  }\n}\n","@import \"./../../styles/mixins\";\n\n.__sidebar_content {\n  width: 50px;\n  height: 100vh;                /* Full viewport height */\n  padding: 25px 21px;           /* Simplified padding */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;      /* Center items vertically */\n  align-items: center;          /* Center items horizontally */\n}\n\n.__menu_item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  width: 100%;                 /* Ensure full width */\n  padding: 10px 0;             /* Adjust padding for spacing */\n}\n\n.__item {\n  margin: 1rem auto;\n  text-align: center;          /* Center text */\n  width: 100%;                 /* Ensure item takes full width */\n\n  &:last-child {\n    margin-top: auto;          /* Flexbox trick to push it to the bottom */\n  }\n}\n\n.__create_playlist {\n  border-radius: 0 0 18px 18px !important;\n  border-top: 0 !important;\n  color: #000000 !important;\n  background-color: #FFEE20 !important;\n}\n\n.__open_button {\n  border-radius: 18px 18px 0px 0px !important;\n  border-bottom: 0 !important;\n  color: #000000 !important;\n  background-color: #FFEE20 !important;\n\n  svg {\n    color: #000000 !important;\n  }\n}\n\n.____transform {\n  transition: transform .2s;\n}\n\n.navButton {\n  background: transparent;\n  justify-content: center;\n  width: 100%;  /* Ensure full width for button */\n  height: 90px;\n}\n\n.navIcon {\n  max-width: 100px;\n  max-height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
